<template lang="pug">
  div
    ReloadAppDialog(:showDialog="showDialog")
    b-row.top-bar
      notifications(group="request" position="top center")
      b-col(md='11' offset-md='1')
        h4 Usuarios ({{pagination.total}})
      b-col(md="4", offset-md='1')
        b-input-group
            b-form-input(v-model="search.text", placeholder="Filtrar por nombre", @keyup.enter.native="fetchUsers(1)")
            b-input-group-button(slot='right')
              b-btn(variant="primary" ,@click="fetchUsers(1)")
                icon(name="search")
      b-col(md='6', align='right')
        b-btn(v-if="$isAllowed('createUser')",variant="primary", @click="createUser") Agregar usuario
    b-row.justify-content-md-center
      b-col(md="10")
        b-table(hover :fields="userFields" :items="users" striped=true)
          template(slot="HEAD_active" scope="active")
            | {{active.label}}
            b-form-group(class="mb-0")
              b-form-select(v-model="search.active" :options="active_options" @input="fetchUsers(1)")
          template(slot="HEAD_role" scope="role")
            | {{role.label}}
            b-form-group(class="mb-0")
              b-form-select(v-model="search.role" :options="role_options" @input="fetchUsers(1)")
          template(slot="actions" scope="thisUser")
            b-button(class="icon-button" variant="link" v-b-tooltip.hover.top="'Editar'" @click="loadUser(thisUser.item)")
              icon(name="edit")
            b-button(class="icon-button" variant="link" v-b-tooltip.hover.top="'Enviar email de recuperación'" @click="recoverPassword(thisUser.item)")
              icon(name="envelope-o")
            b-button(class="icon-button" variant="link" v-b-tooltip.hover.top="'Eliminar usuario'" @click="deleteUser(thisUser.item)")
              icon(name="user-times")
            b-button(class="icon-button" variant="link" v-b-tooltip.hover.top="'Desactivar/Activar cuenta'" @click="shiftActive(thisUser.item)")
              icon(name="ban")
        b-pagination(align="center", :total-rows="pagination.total" v-model="pagination.current",
        :per-page="pagination.per_page" ,@change="changePage" v-if="users.length > 0")
    b-form.form-horizontal(@submit="onSubmit")
      b-modal(v-model="modalShow", :busy="true", size="lg" :title="action === 'create' ? 'Crear nuevo usuario' : 'Editar usuario'" no-close-on-backdrop=true @hide="closeModal(user)")
        b-form-group(label="Correo electrónico")
          b-form-input.form-control(v-model="user.email" v-validate="'required|email'" data-vv-as="correo" name="user[email]" type="email" autocomplete="off" :disabled="user.active")
          span.danger(v-show="errors.has('user[email]')") {{ errors.first('user[email]') }}
        b-form-group(label="Nombre")
          b-form-input.form-control(v-model="user.name" v-validate="'required|min:4'" data-vv-as="nombre" name="user[name]" type="text" autocomplete="off")
          span.danger(v-show="errors.has('user[name]')") {{ errors.first('user[name]') }}
        b-form-group(label="Apellido")
          b-form-input.form-control(v-model="user.last_name" v-validate="'required|min:4'" data-vv-as="apellido" name="user[last_name]" type="text" autocomplete="off")
          span.danger(v-show="errors.has('user[last_name]')") {{ errors.first('user[last_name]') }}
        b-form-group(label="Rol")
          b-form-select(v-model="user.role" v-validate="'required'" data-vv-as="rol" name="user[role]" :options="role_options" autocomplete="off")
          span.danger(v-show="errors.has('user[role]')") {{ errors.first('user[role]') }}
        b-form-group(label="Subteam")
          b-form-select(v-model="user.subteam" v-validate="'required'" data-vv-as="subteam" name="user[subteam]" :options="subteam_options" autocomplete="off")
          span.danger(v-show="errors.has('user[subteam]')") {{ errors.first('user[subteam]') }}
        div(slot="modal-footer")
          b-btn.btn-space(variant="secondary", @click="closeModal(user)") Cancelar
          b-btn.btn-space(variant="primary", type="submit") {{ action === 'create' ? 'Registrar' : 'Actualizar' }}
</template>

<script>
import kexaApi from '@/services/apiService';
import constants from '@/constants/Status.constants';
import usersPerimeter from '@/perimeters/usersPerimeter';
import Selectize from 'vue2-selectize';
import dateService from '@/utils/dateService';

const parse = require('parse-link-header');

export default {
  name: 'users',
  components: [
    Selectize,
  ],
  data() {
    return {
      userFields: {
        email: {
          label: 'Correo Electrónico',
          sortable: true,
        },
        name: {
          label: 'Nombre',
          sortable: true,
        },
        last_name: {
          label: 'Apellido',
          sortable: true,
        },
        role: {
          label: 'Rol',
          formatter: value => this.roles[value].name,
        },
        last_sign_in_at: {
          label: 'Última actividad',
          sortable: true,
          formatter: value => dateService.isValidDate(value),
        },
        active: {
          label: 'Estado',
          formatter: value => (value ? 'Activo' : 'Inactivo'),
        },
        password_last_updated_at: {
          label: 'Edad de contraseña',
          sortable: true,
          formatter: value => dateService.isNan(value),
        },
        confirmation_sent_at: {
          label: 'Edad de clave de activación',
          sortable: true,
          formatter: value => dateService.isNan(value),
        },
        actions: { label: 'Acciones' },
      },
      users: [],
      user: {},
      modalShow: false,
      action: null,
      roles: constants.ROLES,
      search: {
        text: '',
        role: '',
        active: '',
      },
      pagination: {},
      current_page: 1,
      active_options: [
        { value: '', text: 'Seleccione uno' },
        { value: 'true', text: 'Activo' },
        { value: 'false', text: 'Inactivo' },
      ],
      role_options: [
        { value: '', text: 'Seleccione uno' },
        { value: '1', text: '🤖' },
        { value: '2', text: 'CRM' },
        { value: '3', text: 'ERR' },
        { value: '4', text: 'EBD' },
        { value: '5', text: 'FIN' },
      ],
      subteam_options: [
        { value: '', text: 'Seleccione uno' },
        { value: 'EDB', text: 'EDB' },
        { value: 'TD', text: 'Transbank/Devoluciones' },
        { value: 'REC', text: 'Recorrido' },
        { value: 'LTM', text: 'Latam Pass' },
      ],
      showDialog: false,
      intervalId: null,
    };
  },
  perimeters: [usersPerimeter],
  created() {
    this.fetchUsers(1);
  },
  beforeMount() {
    this.refreshReloaAppStatus();
  },
  methods: {
    fetchUsers(page) {
      kexaApi.get_users(page, this.search)
        .then((data) => {
          this.users = data.body;
          this.setPagination(data);
        });
    },
    setPagination(res) {
      const links = Object.prototype.hasOwnProperty.call(res.headers.map, 'links')
        ? parse(res.headers.map.link[0])
        : null;
      const current = res.headers.map.page === undefined
        ? res.headers.map.Page
        : res.headers.map.page;
      const total = res.headers.map.total === undefined
        ? res.headers.map.Total
        : res.headers.map.total;
      const perPage = res.headers.map['per-page'] === undefined
        ? res.headers.map['Per-Page']
        : res.headers.map['per-page'];
      const pagination = {
        current: parseInt(current, 10),
        total: parseInt(total, 10),
        per_page: parseInt(perPage, 10),
        ...links,
      };
      this.pagination = pagination;
    },
    changePage(page) {
      this.current_page = page;
      this.fetchUsers(page);
    },
    loadUser(user) {
      this.beforeEditingCache = Object.assign({}, user);
      this.user = user;
      this.action = 'update';
      this.modalShow = true;
    },
    createUser() {
      this.user = {
        role: '',
        subteam: '',
      };
      this.action = 'create';
      this.modalShow = true;
    },
    registerUser() {
      kexaApi.create_user(this.user)
        .then(() => {
          this.modalShow = false;
          this.fetchUsers(1);
          this.$notify({
            group: 'request',
            type: 'success',
            title: 'Usuario creado con éxito',
            duration: 3000,
          });
        }).catch((response) => { this.notifyError(response); });
    },
    updateUser() {
      kexaApi.update_user(this.user, this.user.id)
        .then(() => {
          this.action = null;
          this.modalShow = false;
          this.fetchUsers(1);
          this.$notify({
            group: 'request',
            type: 'success',
            title: 'Usuario modificado con éxito',
            duration: 3000,
          });
        }).catch((response) => { this.notifyError(response); });
    },
    closeModal(user) {
      if (this.action === 'update') {
        Object.assign(user, this.beforeEditingCache);
      } else {
        this.user = {
          role: '',
          subteam: '',
        };
      }
      this.$validator.reset();
      this.action = null;
      this.modalShow = false;
    },
    onSubmit(event) {
      event.preventDefault();
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (this.action === 'create') {
            this.registerUser();
          } else {
            this.updateUser();
          }
        }
      });
    },
    notifyError(response) {
      if (response.body.email) {
        this.errors.add({
          field: 'user[email]',
          msg: 'El correo electrónico utilizado ya está asociado a otro usuario',
        });
      } else {
        this.$notify({
          group: 'request',
          type: 'error',
          title: 'Error',
          text: response.body,
          duration: 3000,
        });
      }
    },
    deleteUser(user) {
      this.$dialog.confirm({
        title: 'Eliminar usuario',
        body: `¿Estás seguro que deseas borrar al usuario ${user.name}?`,
      }).then(() => {
        kexaApi.delete_user(user.id)
          .then(() => {
            this.fetchUsers(1);
            this.$notify({
              group: 'request',
              type: 'success',
              title: 'Usuario eliminado con éxito',
              duration: 3000,
            });
          });
      }).catch(() => {});
    },
    recoverPassword(user) {
      kexaApi.recover_password(user.id)
        .then(() => {
          this.fetchUsers(1);
          this.$notify({
            group: 'request',
            type: 'success',
            title: 'Correo de recuperación enviado con éxito',
            duration: 3000,
          });
        });
    },
    shiftActive(user) {
      this.$dialog.confirm({
        title: `${user.active ? 'Desactivar' : 'Activar'} cuenta.`,
        body: `¿Estás seguro que deseas ${user.active ? 'desactivar' : 'activar'} la cuenta de ${user.name}?`,
      }).then(() => {
        kexaApi.shift_active(user.id)
          .then(() => {
            this.fetchUsers(1);
            this.$notify({
              group: 'request',
              type: 'success',
              title: `Cuenta ${user.active ? 'desactivada' : 'reactivada'} con éxito`,
              duration: 3000,
            });
          });
      }).catch(() => {});
    },
    refreshReloaAppStatus() {
      this.intervalId = setInterval(() => {
        kexaApi.reloadAppStatus().then((response) => {
          if (response.body) {
            this.showDialog = true;
          }
        });
      }, 900000);
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>

<style lang="scss">
  .btn-space {
    margin-right: 5px;
  }
  .top-bar {
    margin-bottom: 10px;
  }
  .icon-button{
    color: black;
  }
  span.danger {
    color: red;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Users.vue